export const TOGGLE_SCHOOL_YEAR = "TOGGLE_SCHOOL_YEAR"

export const toggleSchoolYear = (sy) => dispatch => {
    try {
        return dispatch({type: TOGGLE_SCHOOL_YEAR, sy: sy.value})
    } catch (error) {
        throw error.message
    }
}